var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgCreatorTag = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 1.75,
    y: 1,
    fill: "#F04438",
    rx: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.653 4c.437 0 .787.36.777.796l-.11 4.408H7.996l-.119-4.407A.776.776 0 0 1 8.653 4ZM8.664 11.794a.912.912 0 0 1-.914-.914c-.006-.493.41-.897.914-.903.486.006.902.41.902.903a.917.917 0 0 1-.902.914Z"
  })));
});
SvgCreatorTag.displayName = "SvgCreatorTag";
export default SvgCreatorTag;